<template>
  <div class="cargo-cascader">
    <el-cascader
      ref="elCascader"
      :value="value"
      :disabled="disabled"
      :options="options"
      :filterable="filterable"
      :class="canCopy?'can-copy':''"
      :placeholder="placeholder"
      :props="{multiple:true}"
      separator="-"
      collapse-tags
      clearable
      @keydown.native.enter.prevent="onEnter"
      @input="onInput"
      @visible-change="onVisibleChange"
    />
    <el-tooltip v-if="canCopy" :content="$t('CargoMsg.Cargo_Copy')" placement="top">
      <el-link class="copy-icon" :underline="false" @click="handleCopy">
        <i class="el-icon-document-copy" />
      </el-link>
    </el-tooltip>
  </div>
</template>

<script>
import { AdvanceSelect, getCacheData } from '@/utils/class/AdvanceSelect'
import { deepCopy } from '@/utils/commonUtil'

export default {
  name: 'CargoCascaderMulti',
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false }, // 不可编辑
    selectType: { type: String, default: '' }, // 下拉控件类型(缓存key)
    filterable: { type: Boolean, default: false }, // 是否允许过滤
    groupField: { type: String, default: '' }, // 分组字段
    groupLabelMap: { type: Object, default: null }, // 分组字段label映射
    tagName: { type: String, default: '' }, // 选项用来显示的字段名
    tagValue: { type: String, default: '' }, // 选项值的字段名
    placeholder: { type: String, default: '' },
    methodParams: {
      type: Object, default: () => {
        return {}
      }
    }, // 过滤条件
    copyFlag: { type: Boolean, default: true } // 是否允许复制
  },
  data() {
    return {
      innerValue: [],
      advanceSelect: null,
      options: [],
      isEdit: false // 是否正在编辑
    }
  },
  computed: {
    canCopy() {
      return this.copyFlag && Boolean(this.value)
    }
  },
  watch: {
    selectType: {
      immediate: true,
      handler() {
        console.log('    this.selectType:' + this.selectType)
        this.advanceSelect = new AdvanceSelect(this.selectType, {}, null, null, { includeAllItem: false })
        this.initOptions()
      }
    },
    value() {
      this.toCustomDisplay()
    }
  },
  methods: {
    async initOptions() {
      const res = await getCacheData(this.selectType, this.advanceSelect, '')
      let dataList = res.data
      for (const filterKey in this.methodParams) {
        const filterValue = this.methodParams[filterKey]
        dataList = this.filterData(filterKey, filterValue, dataList)
      }
      console.log('CargoCascaderMulti----------------', dataList)
      const ownTagName = this.tagName || this.advanceSelect.getTagName()
      const ownTagValue = this.tagValue || this.advanceSelect.getTagValue()
      if (this.groupField) {
        this.options = []
        const map = new Map()
        let data = []
        // 铁出、铁进使用统一数据源(铁出过滤出来，复制一份给铁进，uuid加上‘RI_’来区分)
        if (this.groupLabelMap && Object.keys(this.groupLabelMap).includes('RI') && Object.keys(this.groupLabelMap).includes('RE')) {
          const reItems = deepCopy(dataList.filter(item => item[this.groupField] === 'RE'))
          reItems.map(item => {
            item[this.groupField] = 'RI'
            item[ownTagValue] = 'RI_' + item[ownTagValue]
            return item
          })
          data = dataList.concat(reItems)
        } else {
          data = dataList
        }
        for (const item of data) {
          const groupValue = item[this.groupField]
          let obj = map.get(groupValue)
          if (!obj) {
            obj = {
              label: this.groupLabelMap ? this.groupLabelMap[groupValue] : groupValue,
              value: groupValue,
              children: []
            }
            map.set(groupValue, obj)
            this.options.push(obj)
          }
          obj.children.push({
            label: item[ownTagName],
            value: item[ownTagValue]
          })
        }
      } else {
        this.options = Array.from(dataList, p => { return { label: p[ownTagName], value: p[ownTagValue] } })
      }
      this.innerValue = []
      this.toCustomDisplay()
    },
    //
    filterData(filterKey, filterValue, dateList) {
      const list = []
      for (const index in dateList) {
        const item = dateList[index]
        const value = item[filterKey]
        if (value && value === filterValue) {
          list.push(item)
        }
      }
      return list
    },
    onEnter() {
      this.$emit('enter')
    },
    onInput(val) {
      this.$emit('input', val)
    },
    handleCopy() {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', this.$refs.elCascader.inputValue)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$message.success(this.$t('SeaExport.CopySuccess'))
      }
      document.body.removeChild(input)
    },
    toCustomDisplay() {
      this.$nextTick(() => {
        const cascader = this.$refs.elCascader
        if (!cascader) {
          return
        }
        const tags = cascader.$el.querySelector('.el-cascader__tags')
        if (!tags || !tags.childNodes || tags.childNodes.length === 0) {
          return
        }
        let customDisplay = null
        let searchInput = null
        for (const child of tags.childNodes) {
          if (child.classList.contains('custom-display')) {
            customDisplay = child
          } else if (child.classList.contains('el-cascader__search-input')) {
            searchInput = child
          }
        }
        if (!customDisplay) {
          customDisplay = document.createElement('span')
          customDisplay.className = 'custom-display'
          tags.insertBefore(customDisplay, tags.childNodes[0])
        }
        if (this.isEdit) {
          customDisplay.style.display = 'none'
          if (cascader.inputValue) {
            cascader.inputValue = cascader.inputValue.trim()
          }
          if (cascader.presentText) {
            cascader.presentText = cascader.presentText.trim()
          }
          if (searchInput) {
            searchInput.style.display = ''
            if (searchInput.value) {
              searchInput.value = searchInput.value.trim()
            }
            searchInput.setAttribute('placeholder', this.getDisplay() || this.placeholder)
          }
        } else {
          customDisplay.style.display = ''
          customDisplay.innerText = this.getDisplay()
          customDisplay.setAttribute('title', customDisplay.innerText)
          if (searchInput) {
            searchInput.style.display = 'none'
          }
        }
      })
    },
    getDisplay() {
      const texts = []
      for (const arr of this.value) {
        let option = this.options.find(p => p.value === arr[0])
        if (!option) {
          continue
        }
        let text = option.label
        for (let i = 1; i < arr.length; ++i) {
          if (!option.children) {
            break
          }
          option = option.children.find(p => p.value === arr[i])
          if (!option) {
            break
          }
          text += '-' + option.label
        }
        texts.push(text)
      }
      return texts.join(',')
    },
    onVisibleChange(e) {
      this.isEdit = e
      this.toCustomDisplay()
    }
  }
}
</script>

<style lang="scss" scoped>
.cargo-cascader ::v-deep {
  width: 100%;
  .el-cascader {
    width: 100%;
    &.can-copy .el-input__suffix {
      right: 18px !important;
    }
    .el-cascader__tags {
      .custom-display {
        overflow: hidden;
        white-space: nowrap;
        padding-left: 9px;
      }
      .el-tag--info {
        display: none;
      }
      .el-cascader__search-input {
        margin-left: 9px;
      }
    }
  }
}
.copy-icon {
  position: absolute;
  right: 5px;
}
</style>
